import React, { Fragment } from 'react'
import { Button, Popover } from 'antd'
import './style.css'
import { Link,Redirect } from 'react-router-dom';
export default function MainBottom(props) {
    const { data } = props;
    const content = (
        <img src="images/tempImgs/底部说明/qrCode.png" className='qrCode'>
        </img>
    );
    return (
        <div className='Guide_Bottom'>
            <div className='Guide_BottomMain'>
                <div className='Guide_BottomTitle'>
                    <div className='Guide_BottomTitle_Left'>
                        <img className='Guide_BottomTitle_LeftImg1' src="images/tempImgs/底部说明/netIcon.png" />
                        {/* <img className='Guide_BottomTitle_LeftImg2' src="images/tempImgs/底部说明/netText.png" /> */}
                        <div className='Guide_BottomTitle_LeftText1'>CAPLOS</div>
                    </div>
                </div>
                <div className='Guide_BottomMiddle'>
                    <div className='Guide_BottomLastInfo'>
                        <div className='Guide_BottomLastInfoText1'>
                            Copyright© 中国科学院空天信息创新研究院
                        </div>
                        <div className='Guide_BottomLastInfoText2'>
                            <img className='Guide_BottomLastInfoIcon' src="images/tempImgs/底部说明/public.png" />
                            京ICP备05002787号 京公网安备110402500053号
                        </div>
                    </div>



                    <div className='Guide_BottomMiddle_Left'>
                        <Link to='/AbourUs'><div className='Guide_BottomMiddle_LeftText1'>关于我们</div></Link>
                        <Link to='/JoinUs'><div className='Guide_BottomMiddle_LeftText1'>加入我们</div></Link>
                        <Link to='/ContactUs'><div className='Guide_BottomMiddle_LeftText2'>联系我们</div></Link>
                    </div>
                    <div className='Guide_BottomMiddle_Right'>
                        <div className='Guide_BottomMiddle_RightExplain'>合办单位</div>
                        <div className='Guide_BottomMiddle_RightUnits'>
                            {data.map((unit) => {
                                return (
                                    <a className='Guide_BottomMiddle_RightUnit' href={unit.location}>
                                        <img className='Guide_BottomMiddle_RightUnitIcon' src={unit.icon} />
                                        <div className='Guide_BottomMiddle_RightUnitText'>{unit.title}</div>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                </div>
                {/*<div className='Guide_BottomLastInfo'>*/}
                {/*    <div className='Guide_BottomLastInfoText1'>*/}
                {/*        Copyright© 中国科学院空天信息创新研究院*/}
                {/*    </div>*/}
                {/*    <div className='Guide_BottomLastInfoText2'>*/}
                {/*        <img className='Guide_BottomLastInfoIcon' src="images/tempImgs/底部说明/public.png" />*/}
                {/*        京ICP备05002787号 京公网安备110402500053号*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>
    )
}